export default __webpack_public_path__ + "static/media/baby-27.a29f094c.svg";